<template lang="html">
  <div class="">
    <!-- nav -->
    <div class='nav clearfix' v-bind:class='{scrollnav: scrolltop > 0}'>
      <div class="flex fl nav-box">
        <img src="../img/logo-yeahmobi.png" alt="">
      </div>
      <div class="flex fr nav-box">
        <img src="../img/us.png" class='icon' alt="">
        <a href="#footer-a"><span v-text='contents.mynav.contactus' class='m0-10'></span></a>
        <img src="../img/coun.png" class='icon' alt="">
        <div class="lang-box m0-10">
          <div class="flex pr">
            <div class="langbox cp" v-on:click.stop='showlangbox()'>
              <span v-text='contents.lang'></span>
              <span>▸</span>
            </div>

            <div class="pa langBox cp" v-if='showlang'>
              <ul>
                <li
                v-for='(item, index) in state.contents'
                v-text='item.lang'
                v-bind:class='{clicklang: lang == item.id}'
                v-on:click='changelang(item)'
                ></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="login-box center">
          <a href="http://sdk.test.ssp.net/" class='fb login db' v-text='contents.mynav.login'></a>
        </div>
      </div>
    </div>
    <!-- banner -->
    <div class="banner bgimg pr" v-bind:style='{height: windowh + "px"}'>
      <div class="banner-box full flex fb p-box">
        <div class="flex-column-center-center">
          <div class="banner-title">
            <theater
            v-bind:choicelang="state.choicelang"
            v-bind:contents="contents"></theater>
          </div>
          <div class="banner-dec">
            {{contents.banner.dec}}
          </div>
        </div>
      </div>
      <div class="banner-btn pa flex">
        <a href="javascript:;" class='banner-btn-a db'>
          <img src="../img/banner-btn.gif" alt="">
        </a>
      </div>
    </div>
    <!-- two -->
    <div class="two p-box flex-column-center-center">
      <div class="flex">
        <img class='title' src="../img/why-us-title.png" alt="">
      </div>
      <div class="flex">
        <div class="flex-column-center-center two-box col-auto-8">
          <div class="two-img-box db">
            <img src="../img/two-a.png" alt="">
          </div>
          <div class="full">
            <img src="../img/01.png" alt="">
          </div>
          <div class="full">
            <h3>{{contents.two.title_a}}</h3>
          </div>
          <div class="full two-dec-box">
            <p class='m0'>{{contents.two.dec_a}}</p>
          </div>
        </div>
        <div class="flex-column-center-center two-box col-auto-8">
          <div class="two-img-box db">
            <img src="../img/two-sdk.png" alt="">
          </div>
          <div class="full">
            <img src="../img/02.png" alt="">
          </div>
          <div class="full">
            <h3>{{contents.two.title_b}}</h3>
          </div>
          <div class="full two-dec-box">
            <p class='m0'>{{contents.two.dec_b}}</p>
          </div>
        </div>
        <div class="flex-column-center-center two-box col-auto-8">
          <div class="two-img-box db">
            <img src="../img/two-time.png" alt="">
          </div>
          <div class="full">
            <img src="../img/03.png" alt="">
          </div>
          <div class="full">
            <h3>{{contents.two.title_c}}</h3>
          </div>
          <div class="full two-dec-box">
            <p class='m0'>{{contents.two.dec_c}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- video -->
    <div class="video bgimg flex">
      <div class="video-box full flex-column-center-center jcsb">
        <div class="flex video-title w100">
          <img class='title' src="../img/video-title.png" alt="">
        </div>
        <div class="w100 videofluidbox">
          <div class="video-fluid-box flex" v-bind:class='"videotype" + videotype'>
            <div class="videobox w100 p-box">
              <div class="flex">
                <div class="video-small">
                  <div class="pr db videobox fr">
                    <img src="../img/iphone-a.png" alt="">
                    <div class="pa full videoBox">
                      <div class="full video-docker pr">
                        <video src='http://videocdn.yeahmobi.com/video/output/offer/9199154/offer_single_file/686051/ymCuCikDaHmg9ydl.mp4' class='show-video' poster="">
                          Your browser does not support the video tag.
                        </video>
                        <div class="videomask pa lf0 full" v-if='!scrolltopflagvideo'>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="video-big">
                  <div class='video-title'>{{contents.video.title_a}}</div>
                  <div class="video-dec">
                    <p>{{contents.video.dec_a}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="videobox video-box-b w100 p-box">
              <div class="flex-column-center-center">
                <div class='video-title m0'>{{contents.video.title_b}}</div>
                <div class="pr db videobox-b">
                  <img src="../img/iphone-b.png" alt="">
                  <div class="pa full videoBox-b">
                    <div class="full video-docker pr">
                      <video class='show-video' src="../video/2.mp4" poster="">
                      </video>
                      <div class="videomask pa lf0 full" v-if='!scrolltopflagvideo'>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="video-dec video-dec-b center">
                  <p>{{contents.video.dec_b}}</p>
                </div>
              </div>
            </div>
            <div class="videobox w100 p-box">
              <div class="flex">
                <div class="video-big">
                  <div class='video-title'>{{contents.video.title_c}}</div>
                  <div class="video-dec">
                    <p>{{contents.video.dec_c}}</p>
                  </div>
                </div>
                <div class="video-small">
                  <div class="pr db videobox fr" style='margin-right:50px;'>
                    <img src="../img/iphone-a.png" alt="">
                    <div class="pa full videoBox">
                      <div class="full video-docker pr">
                        <video class='show-video' src="../video/3.mp4" poster="">
                        </video>
                        <div class="videomask pa lf0 full" v-if='!scrolltopflagvideo'>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-video-box flex">
          <div class="tabvideobutton" v-on:click='tabvideo(0)' v-bind:class='{"act": videotype == 0}'></div>
          <div class="tabvideobutton" v-on:click='tabvideo(1)' v-bind:class='{"act": videotype == 1}'></div>
          <div class="tabvideobutton" v-on:click='tabvideo(2)' v-bind:class='{"act": videotype == 2}'></div>
        </div>
      </div>
    </div>
    <!-- adtype -->
    <div class="adtype p-box flex">
      <div class="adtype-box">
        <div class='flex-column-center-center'>
          <div class="flex-column-center-center jcsb ai-end full adtypeBox">
            <div class="left adtypebox adtypebox-up adtypebox-left"
            v-on:click='changeadtype(1)'
            v-bind:class='{"adtype-active": adtype == 1}'
            >
              <div class="full adtype-title right">
                <div>{{contents.adtype.title_a}}</div>
              </div>
              <p>{{contents.adtype.dec_a}}</p>
            </div>
            <div class="left adtypebox adtypebox-down adtypebox-left"
            v-on:click='changeadtype(2)'
            v-bind:class='{"adtype-active": adtype == 2}'
            >
              <div class="full adtype-title right">
                <div>{{contents.adtype.title_b}}</div>
              </div>
              <p>{{contents.adtype.dec_b}}</p>
            </div>
          </div>
        </div>
        <div class='adtype-middle-box db pr'>
          <img src="../img/adtype-iphone.png" alt="">
          <div class="pa lf0 full adtype-middlebox">
            <div class="adtypemiddlebox full">
              <transition name="animatetypeb">
                <div class="" v-if='adtype == 1'>
                  <img src="../img/adtype-native.png" alt="">
                </div>
              </transition>
              <transition name="animatetypeb">
                <div class="" v-if='adtype == 2'>
                  <img src="../img/adtype-appwall.png" alt="">
                </div>
              </transition>
              <transition name="animatetypeb">
                <div class="" v-if='adtype == 3'>
                  <img src="../img/adtype-banner.png" alt="">
                </div>
              </transition>
              <transition name="animatetypeb">
                <div class="" v-if='adtype == 4'>
                  <img src="../img/adtype-interstitial.png" alt="">
                </div>
              </transition>
            </div>
          </div>
        </div>
        <div class='clearfix flex-column-center-center'>
          <div class="flex-column-center-center jcsb ai-start full adtypeBox">
            <div class="left adtypebox adtypebox-up adtypebox-right"
            v-on:click='changeadtype(3)'
            v-bind:class='{"adtype-active": adtype == 3}'
            >
              <div class="full adtype-title">
                <div>{{contents.adtype.title_c}}</div>
              </div>
              <p>{{contents.adtype.dec_c}}</p>
            </div>
            <div class="left adtypebox adtypebox-down adtypebox-right"
            v-on:click='changeadtype(4)'
            v-bind:class='{"adtype-active": adtype == 4}'
            >
              <div class="full adtype-title">
                <div>{{contents.adtype.title_d}}</div>
              </div>
              <p>{{contents.adtype.dec_d}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <footer>
      <div class="flex jcsb footerBox ai-start" id='footer-a'>
        <div class="footer-box ai-start jc-start">
          <img src="../img/logo-yeahmobi.png" alt="">
          <div class="p10">
            {{contents.footer.copy}}
          </div>
        </div>
        <div class="footer-box">
          <div class="flex jc-start p10">
            <div class="footer-title">
              {{contents.footer.emall_title}}
            </div>
            <div class="footer-text">
              sdk_support@yeahmobi.com
            </div>
          </div>
          <div class="flex jc-start p10">
            <div class="footer-title">
              {{contents.footer.phone_title}}
            </div>
            <div class="footer-text">
              (+86)010-82860172
            </div>
          </div>
          <div class="flex jc-start p10">
            <div class="footer-title">
              {{contents.footer.qq_title}}
            </div>
            <div class="footer-text">
              348568688
            </div>
          </div>
          <div class="flex jc-start p10">
            <div class="footer-title">
              {{contents.footer.skype_title}}
            </div>
            <div class="footer-text">
              sdk_support@yeahmobi.com
            </div>
          </div>
        </div>
        <div class="footer-box ai-start jc-start">
          <div class="flex jc-start ai-start p10">
            <div class="footer-title">
              {{contents.footer.address_title}}
            </div>
            <div class="address-box">
              <div class="">
                {{contents.footer.address.a}}
              </div>
              <div class="">
                {{contents.footer.address.b}}
              </div>
              <div class="">
                {{contents.footer.address.c}}
              </div>
              <div class="">
                {{contents.footer.address.d}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- 翻页按钮 -->
    <div class="scroll-box flex">
      <div class="scrollbox flex-column-center-center">
        <div class="clickbutton"
        v-bind:class='{"act": scrolltoparr.banner <= handlescrolltop && handlescrolltop < scrolltoparr.two}'
        v-on:click='goscrolltop(scrolltoparr.banner)'
        ></div>
        <div class="clickbutton"
        v-bind:class='{"act": scrolltoparr.two <= handlescrolltop && handlescrolltop < scrolltoparr.video}'
        v-on:click='goscrolltop(scrolltoparr.two)'
        ></div>
        <div class="clickbutton"
        v-bind:class='{"act": scrolltoparr.video <= handlescrolltop && handlescrolltop < scrolltoparr.adtype}'
        v-on:click='goscrolltop(scrolltoparr.video)'
        ></div>
        <div class="clickbutton"
        v-bind:class='{"act": scrolltoparr.adtype <= handlescrolltop}'
        v-on:click='goscrolltop(scrolltoparr.adtype)'
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import theater from './theater.vue'
import Velocity from 'velocity-animate'
export default {
  data () {
    return {
      videotype: null,
      windowh: null,
      scrolltop: null,
      showlang: false,
      adtype: 1,
      scrolltoparr: {
        video: null,
        banner: null,
        two: null,
        adtype: null
      },
      scrolltopflagvideo: false
    }
  },
  components: {
    theater
  },
  computed: {
    state () {
      return this.$store.state
    },
    handlescrolltop () {
      return this.scrolltop + 200
    },
    ...mapGetters(['lang', 'contents'])
  },
  created: function () {
    var vm = this
    vm.getwindowhieght()
    window.onresize = function () {
      vm.getwindowhieght()
    }
  },
  mounted: function () {
    var vm = this
    vm.hidelangbox()
    vm.getscrolltop()
    window.onscroll = function () {
      vm.getscrolltop()
      vm.getdockerscrolltop()
    }
    this.judevideotype()
  },
  watch: {
    scrolltopflagvideo: function (newval) {
      if (newval) {
        this.getvideoobj()
      }
    }
  },
  methods: {
    ...mapActions(['increment']),
    // 获取window的高度
    getwindowhieght: function () {
      this.windowh = window.innerHeight
      if (this.windowh < 580) {
        this.windowh = 580
      }
      // console.log(this.windowh)
    },
    // 获取滚轮位置
    getscrolltop: function () {
      this.scrolltop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.judevideoflag()
    },
    // 获取各容器到顶部的距离
    getdockerscrolltop: function () {
      this.scrolltoparr.video = document.querySelector('.video').offsetTop - 70
      this.scrolltoparr.banner = document.querySelector('.banner').offsetTop
      this.scrolltoparr.two = document.querySelector('.two').offsetTop - 70
      this.scrolltoparr.adtype = document.querySelector('.adtype').offsetTop - 70
      this.judevideoflag()
    },
    // 语言切换
    changelang: function (item) {
      this.increment(item.id)
    },
    // 显示语言切换容器
    showlangbox: function () {
      this.showlang = true
    },
    // 隐藏语言切换容器
    hidelangbox: function () {
      var vm = this
      document.addEventListener('click', function (e) {
        vm.showlang = false
        // e.stopPropagation()
      }, true)
    },
    // 鼠标滚轮事件
    wheelevent: function () {
    },
    // 切换adtype
    changeadtype: function (data) {
      this.adtype = data
    },
    // 获取视频对象
    getvideoobj: function () {
      var vm = this
      var videoobj = document.querySelectorAll('.show-video')
      videoobj.forEach(function (ele, index) {
        if (index.toString() === vm.videotype.toString()) {
          ele.load()
          ele.oncanplay = function (e) {
            this.muted = true
            this.play()
          }
          ele.onended = function () {
            // 切换videotype
            vm.changevideotype()
          }
        } else {
          ele.load()
          ele.oncanplay = function (e) {
            ele.pause()
          }
        }
      })
    },
    // 改变videotype
    changevideotype: function () {
      this.videotype++
      if (this.videotype > 2) {
        this.videotype = 0
      }
      this.setlocalStoragevideotype()
      this.getvideoobj()
    },
    // 判断视频类型
    judevideotype: function () {
      var localStoragevideotype = localStorage.getItem('videotype')
      if (localStoragevideotype) {
        this.videotype = parseFloat(localStoragevideotype)
      } else {
        this.videotype = 0
        this.setlocalStoragevideotype()
      }
    },
    // 判断视频开关
    judevideoflag: function () {
      if (this.scrolltop > this.scrolltoparr.video && this.scrolltoparr.video) {
        this.scrolltopflagvideo = true
      }
    },
    // 缓存视频类型到本地
    setlocalStoragevideotype: function () {
      var vm = this
      localStorage.setItem('videotype', vm.videotype)
    },
    goscrolltop (data) {
      Velocity(document.body, 'scroll', { offset: data }, { duration: 300 })
    },
    tabvideo (num) {
      this.videotype = num
      this.getvideoobj()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index.vue